export function createFileModelForm ( fileModel ) {
    return "fileModelConfig" + ( fileModel && fileModel.id || 0 );
}

export function createFileModelSectionForm ( fileModelSection ) {
    return "fileModelSectionConfig" + ( fileModelSection && fileModelSection.id || 0 );
}